"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitUntil = waitUntil;

var _waitUntilAction = require("../redux/middleware/waitUntilAction");

function waitUntil(_ref) {
  let {
    predicate,
    run
  } = _ref;
  return {
    type: _waitUntilAction.WAIT_UNTIL_ACTION,
    predicate,
    run
  };
}